import { IBriefResource } from "../../briefs";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICalendarEventResource } from "../types";

export type ICalendarEventUpdateMutationParameters = {
    calendarEvent: RelationalValue<ICalendarEventResource>;
    data: {
        title?: string;
        date?: string;
        startTime?: string;
        endTime?: string;
        brief?: RelationalValue<IBriefResource>;
        location?: string;
        description?: string;
    };
};

export type ICalendarEventUpdateMutationResult = ICalendarEventResource;

export const calendarEventUpdateMutation: IApiMutationFunction<ICalendarEventUpdateMutationParameters> = ({
    calendarEvent,
    data,
}) => {
    const { brief, ...rest } = data;
    return {
        method: "PATCH",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}`,
        data: {
            ...rest,
            briefId: mapRelationalValue(brief),
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useCalendarEventUpdateMutation = createApiMutationHook<
    ICalendarEventUpdateMutationParameters,
    ICalendarEventUpdateMutationResult
>(calendarEventUpdateMutation);
